import { useEffect } from "react";

export default function Toast({ type = "success", message, onClose, duration = 3000 }) {
  useEffect(() => {
    const t = setTimeout(onClose, duration);
    return () => clearTimeout(t);
  }, [onClose, duration]);

  return (
    <div className={`toast toast-${type}`}>
      {message}
    </div>
  );
}
